var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Row } from "@brushfire/ui";
import { useContext } from "react";
import { setPaymentRequiredPayload } from "../../../store/PostAttendeeActions/actions";
import { PaymentPayloadType } from "../../../store/PostAttendeeActions/types";
import { putAttendeeType } from "../../../data/api";
import { useDispatch } from "react-redux";
import { handleErrors, handleSubmittedOrder } from "../../../data/helpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import WidgetSticky from "../../Helpers/WidgetSticky";
import Skeleton from "@material-ui/lab/Skeleton";
import AttendeeTypes from "../Register/Steps/AttendeeTypes";
import { clearInlineErrors, setFormIsSubmitting, setInlineError } from "../../../store/AppState/actions";
import { AppFormContext } from "../../../App";
import NoChangesAfterMessage from "./NoChangesAfterMessage";
import useFormatters from "../../../hooks/useFormatters";
import Constants from "../../../data/constants";
import InlineError from "../../UI/InlineError";
var MyAttendeeType = function (_a) {
    var _b, _c;
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, currentAttendeeTypeInfo = _a.currentAttendeeTypeInfo, setSuccessMessage = _a.setSuccessMessage, typeCode = _a.typeCode, attendeeListUrl = _a.attendeeListUrl;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var formikContext = useContext(AppFormContext).formikContext;
    var formatCurrency = useFormatters().formatCurrency;
    var hasPricedTypes = currentAttendeeTypeInfo === null || currentAttendeeTypeInfo === void 0 ? void 0 : currentAttendeeTypeInfo.types.some(function (t) {
        var _a;
        return t.displayAmount !==
            ((_a = currentAttendeeTypeInfo.types.find(function (t) { return t.id === attendee.attendeeTypeId; })) === null || _a === void 0 ? void 0 : _a.displayAmount);
    });
    var currentType = currentAttendeeTypeInfo === null || currentAttendeeTypeInfo === void 0 ? void 0 : currentAttendeeTypeInfo.types.find(function (t) { return t.id === attendee.attendeeTypeId; });
    var currentPrice = ((_b = currentType === null || currentType === void 0 ? void 0 : currentType.amount) !== null && _b !== void 0 ? _b : 0) + ((_c = currentType === null || currentType === void 0 ? void 0 : currentType.fee) !== null && _c !== void 0 ? _c : 0);
    var onSubmit = function (values, formikHelpers, setGlobalError, attendeeTypeId) {
        var _a, _b, _c, _d;
        dispatch(clearInlineErrors(["updatePAAType"]));
        var parsedTypeId = attendeeTypeId;
        var externalId = "";
        var externalDescription = "";
        if (attendeeTypeId.includes("|")) {
            var parts = attendeeTypeId.split("|");
            parsedTypeId = parts[0];
            externalId = parts[1];
            externalDescription = parts[2];
        }
        var newType = currentAttendeeTypeInfo === null || currentAttendeeTypeInfo === void 0 ? void 0 : currentAttendeeTypeInfo.types.find(function (t) { return t.id === parsedTypeId; });
        if (newType) {
            var payload_1 = {
                attendeeTypeId: parsedTypeId,
                typeCode: typeCode !== null && typeCode !== void 0 ? typeCode : "",
                amount: !newType.allowCustomAmount && ((_b = (_a = newType.allowedPayments) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 0
                    ? null
                    : (_d = (_c = values.attendees.find(function (a) { return a.typeId === attendeeTypeId; })) === null || _c === void 0 ? void 0 : _c.amount) !== null && _d !== void 0 ? _d : null,
                externalId: externalId,
                externalDescription: externalDescription,
            };
            putAttendeeType(attendee === null || attendee === void 0 ? void 0 : attendee.id, payload_1)
                .then(function (res) {
                if (res.status === 202) {
                    dispatch(setPaymentRequiredPayload({
                        type: PaymentPayloadType.attendeeTypeChange,
                        payload: res.data,
                        originalFields: payload_1,
                        summaryText: "You're about to change your ".concat(eventData.verbiage === "Tickets" ? "ticket" : "registration", " to \"").concat(newType.name, "\", resulting in a").concat(res.data.total > 0 ? "n additional charge of " : " refund of ").concat(formatCurrency(res.data.total)),
                    }));
                }
                else {
                    setSuccessMessage("Attendee Type Changed");
                    formikHelpers.resetForm({ values: values });
                    var orderResult = res.data;
                    handleSubmittedOrder(orderResult.result, eventData, history, true, attendeeListUrl);
                }
            })
                .catch(function (err) {
                dispatch(setInlineError({ updatePAAType: err.response.data.message }));
                if (formikContext) {
                    handleErrors(err, dispatch, formikContext);
                }
            })
                .finally(function () {
                setTimeout(function () {
                    formikHelpers.setSubmitting(false);
                    dispatch(setFormIsSubmitting(false));
                }, 500);
            });
        }
    };
    if (!currentAttendeeTypeInfo) {
        return (_jsx(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: true }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }) })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(InlineError, { id: "updatePAAType" }), (hasPricedTypes || currentAttendeeTypeInfo.changesAreBlocked || (attendee === null || attendee === void 0 ? void 0 : attendee.hasUnpaidInvoice)) && (_jsx(NoChangesAfterMessage, { changesAreBlocked: currentAttendeeTypeInfo.changesAreBlocked, changesAreBlockedAfter: currentAttendeeTypeInfo === null || currentAttendeeTypeInfo === void 0 ? void 0 : currentAttendeeTypeInfo.changesAreBlockedAfter, attendeeChange: eventData.attendeeChanges, hasUnpaidInvoice: attendee === null || attendee === void 0 ? void 0 : attendee.hasUnpaidInvoice })), _jsx(AttendeeTypes, { eventData: eventData, path: path, activePaths: [Constants.Routes.myAttendeeType], setGroupsMode: function () { return null; }, attendeeTypeData: currentAttendeeTypeInfo.types, currentAttendeeTypeId: attendee.externalId ? "".concat(attendee.attendeeTypeId, "-").concat(attendee.externalId) : attendee.attendeeTypeId, isSingleAttendeePicker: true, handleSubmit: onSubmit, typeCode: typeCode, setSourceAttendee: function () { return null; }, currentAttendeeTypePrice: currentPrice, isDisabled: currentAttendeeTypeInfo.changesAreBlocked, isAddonMatrix: currentAttendeeTypeInfo.types.every(function (x) { return x.isAddon; }), hasUnpaidInvoice: attendee === null || attendee === void 0 ? void 0 : attendee.hasUnpaidInvoice })] }));
};
export default MyAttendeeType;
